<template>
  <div>
    <d-row>
      <d-col lg="12">
        <h5>Specifications</h5>

        <d-row>
          <template v-for="(specification, i) in Object.values(specifications)">
            <d-col :key="i">
              <h6>{{specification.label}}</h6>

              <template v-for="(item, i) in specification.items">
                <d-checkbox v-model="item.selected" :key="i" style="font-weight: 400;">{{item.label}}</d-checkbox>
              </template>
            </d-col>
          </template>
        </d-row>
      </d-col>

<!--  <d-col lg="5">
        <h5>Extra options</h5>

        <d-alert show>
          <i class="fa fa-info"></i>
          <span>If you enter a zero <strong>(0)</strong> for an option's availability, it means that this option is always available, no matter how many bookings there are for that option.</span>
        </d-alert>

        <d-alert show>
          <i class="fa fa-info"></i>
          <span>Please enter the price using a period (.) as decimal separator when entering a price (e.g. 6.32).</span>
        </d-alert>

        <d-row>
          <d-col />
          <d-col lg="3"><h6>Price</h6></d-col>
          <d-col lg="4"><h6>Available spots</h6></d-col>
        </d-row>

        <template v-for="(option, i) in options">
          <d-row :key="i">
            <d-col style="display: flex; align-items: center;">
              <d-checkbox v-model="option.available" style="font-weight: 400;">{{option.label}}</d-checkbox>
            </d-col>

            <d-col lg="3">
              <d-input-group prepend="€" class="mb-3">
                <d-input v-model="option.price" :disabled="!option.available" />
              </d-input-group>
            </d-col>

            <d-col lg="4">
              <d-input v-model="option.availability" :disabled="!option.available" />
            </d-col>
          </d-row>
        </template>
      </d-col>-->

    </d-row>

    <d-button theme="primary" @click="onSubmit">Save Changes</d-button>
  </div>
</template>

<script>
export default {
  methods: {
    onSubmit: async function (event) {
      event.preventDefault();

      // Gather the selected features.
      const features = [];

      Object.values(this.specifications).forEach(category => {
        category.items.forEach(feature => {
          if (feature.selected) {
            features.push(feature.id);
          }
        });
      });

      // Gather the extra options.
      const extraOptions = [];

      this.options.forEach(option => {
        if (option.availability === undefined) {
          return;
        }

        extraOptions.push({
          availability: parseInt(option.availability),
          available: option.available,
          currency: option.currency,
          price: parseFloat(option.price),
          id: option.id,
        });
      });

      // Update the provider.
      const data = await this.$apollo.mutate({
        mutation: require('~/graphql/parkings/UpdateFeatures.gql'),
        variables: {
          id: this.parking.id,
          features: features,
          extraOptions: extraOptions,
        },
      });

      if (data.data.updateProvider.provider) {
        window.location.reload(true);
      }
    },

    isDirty: () => false,
  },

  apollo: {
    load: function () {
      return {
        fetchPolicy: 'no-cache',
        update: function (data) {
          // Load the features.
          const specifications = [];

          data.features.forEach(feature => {
            if (typeof specifications[feature.category] === 'undefined') {
              specifications[feature.category] = {
                label: feature.category.charAt(0).toUpperCase() + feature.category.slice(1),
                items: [],
              };
            }

            specifications[feature.category].items.push({
              selected: this.parking.features.indexOf(feature.id) !== -1,
              label: feature.localizedTitle,
              id: feature.id,
            });
          });

          this.specifications = specifications;

          // Load the extra options.
          this.options = [];

          data.extraOptions.forEach(extraOption => {
            const providerExtraOption = this.parking.extraOptions.find(providerExtraOption => providerExtraOption.extraOption.id === extraOption.id);

            this.options.push({
              availability: providerExtraOption && providerExtraOption.availability >= 0 ? providerExtraOption.availability : undefined,
              available: (providerExtraOption && providerExtraOption.available) || false,
              currency: (providerExtraOption && providerExtraOption.currency) || 'EUR', // TODO: This needs to come from the price.
              label: extraOption.localizedTitle,
              price: (providerExtraOption && providerExtraOption.price) || undefined,
              id: extraOption.id,
            });
          });
        },
        query: require('~/graphql/GetFeatures.gql'),
      };
    },
  },

  props: {
    parking: {
      required: true,
      type: Object,
    },
  },

  data: function () {
    return {
      specifications: [],
      options: [],
    };
  },
};
</script>
